export const MFA_TYPE = {
  NOMFA: 'NOMFA',
  TOTP: 'TOTP',
  EMAIL: 'EMAIL',
};
